import _ from "lodash";

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Button from "@mui/material/Button";

import { ICON_LIST } from './constants';
import theme from "../../theme";

const tableComponent = {
  text: ({ header, rowData }) => {
    const { id } = header;
    const value = _.get(rowData, id);

    return value ? value : '...';
  },
  icon: ({ header, rowData, handleTableAction }) => {
    const { id, name, icon } = header;
    const IconComponent = ICON_LIST[icon];

    return (
      <>
        {
          IconComponent ? (
            <IconButton
              variant='main'
              onClick={(e) => handleTableAction(e, { id, data: rowData })}
            >
              <IconComponent />
            </IconButton>
          ) : (
            <Button
              variant="outlined"
              onClick={(e) => handleTableAction(e, { id, data: rowData })}
            >
              {name}
            </Button>
          )
        }
      </>
    )
  },
  created_datetime: ({ header, rowData }) => {
    const { id } = header;
    const value = _.get(rowData, id);
    const displayValue = value ? value.replace('T', ' ') : '...';

    return displayValue;
  },
  job_status: ({ header, rowData }) => {
    const { id } = header;
    const value = _.get(rowData, id);
    let color;

    if (value === 'PENDING') {
      color = theme.palette.primary.main;
    } else if (value === 'ENDED') {
      color = theme.palette.error.main;
    } else if (value === 'RUNNING') {
      color = theme.palette.secondary.main;
    } else {
      color = theme.palette.grey.main;
    }

    return <Typography color={color}>{value}</Typography>
  }
}

const TableContent = (props) => {
  const {
    header,
    rowData
  } = props;

  const { type, render } = header;

  return (
    <>
      {
        !render && tableComponent[type]({ ...props })
      }
      {
        render && tableComponent[render]({ ...props })
      }
    </>
  )
}

export default TableContent;